<template>
  <b-nav-item-dropdown
    id="advanced-search"
    menu-class="advanced-dropdown"
    text="ÖSSZETETT KERESÉS"
    @shown="onShow"
  >
    <search-form
      id="search_form"
      ref="search_form"
      :url="url"
      :min_price="min_price"
      :max_price="max_price"
    />
  </b-nav-item-dropdown>
</template>

<script>
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import {namespace} from 'vuex-class';

  const searchModule = namespace('search');

  @Component
  export default class SearchMenu extends Vue {
    @Prop(String) url;
    @Prop(Boolean) commercial;
    @Prop(Number) min_price;
    @Prop(Number) max_price;

    @searchModule.State('filters') filters;
    @searchModule.Mutation('setFilters') setFilters;

    created() {
      if (this.commercial) {
        const filters = {...this.filters, commercialVehicle: true};
        this.setFilters(filters);
      }
    }

    onShow() {
      this.$refs['search_form'].initializeState();
    }
  }
</script>
